import { Component, OnInit, Output, EventEmitter, Input, ViewChild, SimpleChanges, OnChanges, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject, timer } from 'rxjs';
import { MessagebarComponent } from 'basecomponents';
import { Router, ActivatedRoute } from '@angular/router';
import { SolarBase1Component } from '@solar/solar/solar-base';
import { GlobalService } from '@solar/services/global.service';
import { CountryPickerService } from 'basecomponents';
import { Site } from 'solar-bo';
import { SolarService } from '@solar/solar/services/solarservice.service';
import { FrCoordinate, mapcte, OlMainComponent } from 'gmap';
import { MapSiteHelper } from '@solar/ol';


import { easeOut } from 'ol/easing';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import { getVectorContext } from 'ol/render';
import { Stroke, Style } from 'ol/style';
import CircleStyle from 'ol/style/Circle';
import { unByKey } from 'ol/Observable';
import { take, takeUntil, takeWhile } from 'rxjs/operators';
import { SiteConfigComponent } from '../site-config/site-config.component';


@Component({
  selector: 'app-site-edit',
  templateUrl: './site-edit.component.html'
})
export class SiteEditComponent extends SolarBase1Component implements OnInit, AfterViewInit {

  TAG = "SiteEditComponent";
  @Output() saveEvent = new EventEmitter<Site>();
  private _site: Site = new Site();
  @Input()
  public get site(): Site {
    return this._site;
  }
  public set site(value: Site) {
    console.log(this.TAG + " site set", value);
    this._site = value;
    this.setForm();
    this.congfigSiteLocation(value);
  }
  @Input() ismodal: boolean = false;
  @ViewChild('frmsmessagebar') frmsmessagebar: MessagebarComponent;

  @ViewChild('map') map: OlMainComponent;
  @ViewChild('sitepanelconfig') sitepanelconfig: SiteConfigComponent;
  @Input() options: { mapVisible: boolean } = { mapVisible: false };
  showMap: boolean = false;
  public countries: any[];
  //UI
  panelOpenState = false;
  //@ViewChild('editform') public editform: NgForm;

  public constructor(
    public dialog: MatDialog
    , public globService: GlobalService
    , public route: ActivatedRoute
    , public solarService: SolarService
    , public router: Router
    , private fb: FormBuilder
    , private countryPickerService: CountryPickerService
  ) {
    //super(dialog, globService,route,baseService,router);
    super();
    this.createForm();
    //this.countryPickerService.getCountries().subscribe(countries => this.countries =CountryPickerService.sortCountries(countries,"name.common"));
    this.countryPickerService.getCountries().subscribe(res => this.countries = res);
  }

  ngOnInit() {
    this.setForm();
    this.loading = false;
  }

  /*ngOnChanges(changes: SimpleChanges) {
    console.log(this.TAG+ " ngOnChanges",changes);
    const typeChange = changes['site'];
     if ((typeChange && !typeChange.firstChange) && typeChange.currentValue != undefined) {
      this.site = typeChange.currentValue;
      console.log("ngOnChanges", this.site);
      this.setForm();

    }
  }*/

  ngAfterViewInit() {
    console.log(this.TAG + " ngAfterViewInit");
    if (this.options.mapVisible) {
      this.showMap = true;
      this.showMapAsync();
    }
  }



  private showMapAsync() {
    if (this.options.mapVisible) {
      timer(100, 100)
        .pipe(takeWhile(val_notused => this.map == null, true))
        .subscribe(val => {
          this.configMap(this);
        });
    }

  }


  private configMap(cls: SiteEditComponent) {
    if (!cls.map) {
      return;
    }
    cls.map.layerHide(mapcte.RASTERPANELS);//desactivar capa raster panels
    cls.map.setZoom(2);

  }

  private congfigSiteLocation(site: Site) {
    let cls = this;
    if (!site) {
      return;
      //borrar capa?
    }

    timer(50, 100)
      .pipe(takeWhile(val_notused => cls.map == null, true))
      .subscribe(val => {
        if (cls.map) {
          MapSiteHelper.drawSitesOnMap(cls.map, cls.site.name, "sitemarker_" + site.id, [site]);
          cls.map.setZoom(2);
          if (this.site.info.location != null) {
            cls.map.setLocation([site.info.location[0], site.info.location[1]]);
          }
        }

      });
  }

  isvalid() {
    return this.myform.valid && !this.submitted;
  }

  ui_showbtn(button: string): boolean {
    return this.acl_btn_bysite(button, this.site);

  }

  createForm() {
    this.myform = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      description: [''],
      //geom:['', [Validators.required] ],
      latitud: ['', [Validators.required]],
      longitud: ['', [Validators.required]],
      power: ['', [Validators.required, Validators.min(0)]],
      country: [null, Validators.required],
      zone: [''],
    });
    //name: ['', [Validators.required, Validators.email]],
    // name: ['', [Validators.required, Validators.minLength(3)] ],
  }

  setForm() {
    //console.log("setform", this.site);
    if (this.site == null) {
      return;
    }

    const obj = this.site;
    if (!obj.info.location) {
      obj.info.location = [0, 0];
    }
    let latitud = obj.info.location[1];
    let longitud = obj.info.location[0];
    this.myform.reset({
      name: obj.name,
      description: obj.description,
      //geom: JSON.stringify(obj.geom),
      latitud: latitud,
      longitud: longitud,
      power: obj.info.power,
      country: obj.info.country,
      zone: obj.info.zone,
    });
  }


  prepareSave(): any {
    //como ejemplo, en nuestro caso es el mismo objeto
    const formModel = this.myform.value;
    const cloneModel: Site = new Site();
    if (this.site) {
      cloneModel.id = this.site.id;
      cloneModel.info = this.site.info;
    }
    else {

    }

    cloneModel.name = formModel.name;
    cloneModel.description = formModel.description;
    cloneModel.info.updating_date = new Date();
    cloneModel.info.updated_by = this.globService.currentUserValue.id;
    cloneModel.info.power = formModel.power;
    cloneModel.info.location = [formModel.longitud, formModel.latitud];
    cloneModel.info.country = formModel.country;
    cloneModel.info.zone = formModel.zone;

    const panelConfig = this.sitepanelconfig.getConfig();
    cloneModel.info.locator = panelConfig.locator;
    cloneModel.info.report = panelConfig.report_locator;
    cloneModel.info.panel_locator_pattern = panelConfig.panel_locator_pattern;
    //cloneModel.geom = JSON.parse(formModel.geom);
    return cloneModel;
  }


  saveModel(value?: any) {
    this.submitted = true;
    this.loading = true;
    this.alertmessage = null;
    try {

      const clonemodel = this.prepareSave();
      console.log("Site-Edit saveModel start", clonemodel);
      this.solarService.siteEditCreate(clonemodel)
        .subscribe((res) => this.savehandleresult(res), err => this.savehandleError(err)
        );
    } catch (error) {
      this.submitted = false;
      this.loading = false;
      this.showerror(error);
      console.log(error);
    }
  }

  savehandleresult(resultmodel: Site) {
    console.log("site saved:", resultmodel);
    try {
      this.submitted = false;
      this.loading = false;
      this.showmessage('Site saved ');

      if (this.site == null) {
        //creando
        this.site = resultmodel;
      }
      else {
        //editando asignamos los valores que necesitamos, porque no sabemos si el servicio devuelve todo o solo lo que interesa.
        this.site.name = resultmodel.name;
        this.site.description = resultmodel.description;
        this.site.info = resultmodel.info;

        //this.site.geom=resultmodel.geom;
        //si hay otros campos que necesitamos actualizar hay que añadirlos aqui
      }
      console.log("site saved before raise event", resultmodel);
      this.saveEvent.emit(this.site);
      console.log("site saved after  raise event", resultmodel);
    } catch (error) {
      this.submitted = false;
      this.loading = false;
      this.showerror(error);
      console.log(error);
    }

  }

  savehandleError<T>(err: any) {
    this.handleError(err);
  }

  handleError<T>(err: any) {
    this.submitted = false;
    this.loading = false;
    this.showerror("Error saving site. Message: " + err.message);
    console.error('An error occurred:', err.message);
  }


  tileLayer: any;
  /*    = new TileLayer({
      source: new OSM({
        wrapX: false,
      }),
    }); */

  duration = 3000;
  flash(feature) {
    var start = new Date().getTime();
    var listenerKey = this.tileLayer.on('postrender', animate);

    function animate(event) {
      var vectorContext = getVectorContext(event);
      var frameState = event.frameState;
      var flashGeom = feature.getGeometry().clone();
      var elapsed = frameState.time - start;
      var elapsedRatio = elapsed / this.duration;
      // radius will be 5 at start and 30 at end.
      var radius = easeOut(elapsedRatio) * 25 + 5;
      var opacity = easeOut(1 - elapsedRatio);

      var style = new Style({
        image: new CircleStyle({
          radius: radius,
          stroke: new Stroke({
            color: 'rgba(255, 0, 0, ' + opacity + ')',
            width: 0.25 + opacity,
          }),
        }),
      });

      vectorContext.setStyle(style);
      vectorContext.drawGeometry(flashGeom);
      if (elapsed > this.duration) {
        unByKey(listenerKey);
        return;
      }
      // tell OpenLayers to continue postrender animation
      this.map.render();
    }
  }

}
